import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";

const NotFound = lazy(() => import("../../container/pages/404"));
const CountriesList = lazy(() =>
  import("../../container/countries/CountriesList")
);
const AddCountry = lazy(() =>
  import("../../container/countries/components/createCountryForm")
);

function IconsRoute() {
  return (
    <Routes>
      <Route path="/" element={<CountriesList />} />
      <Route path="/add-country" element={<AddCountry />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default IconsRoute;
